import { StyleSheet } from 'react-native';
import { pageContainerStyle, stdCouleurBleu } from '@commonStyle';

const tooltipContainerWidth = 50;
const styles = StyleSheet.create({
  container: {
    ...pageContainerStyle,
    backgroundColor: '#ffffff',
    paddingHorizontal: 16,
    paddingVertical: 20,
  },
  pageSubtitle: {
    fontSize: 16,
    color: '#64748b',
    marginBottom: 24,
    textAlign: 'center',
    fontWeight: '500',
  },

  yearSelector: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 24,
    paddingHorizontal: 20,
  },

  yearText: {
    fontSize: 16,
    color: '#64748b',
    textAlign: 'center',
    fontWeight: '500',
    marginHorizontal: 16,
    // Suppression de marginBottom pour un alignement parfait
  },

  yearArrow: {
    padding: 12,
    borderRadius: 8,
    backgroundColor: 'white',
    borderWidth: 1,
    borderColor: '#e2e8f0',
    alignItems: 'center',
    justifyContent: 'center',
    marginHorizontal: 16,
    // Ombres pour iOS et Web
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    // Elevation pour Android
    elevation: 1,
  },

  listContainer: {
    padding: 5,
  },

  bulletinContainer: {
    backgroundColor: 'white',
    borderRadius: 12,
    marginBottom: 12,
    // Ombres pour iOS et Web
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    // Elevation pour Android
    elevation: 3,
    borderWidth: 1,
    borderColor: '#e2e8f0',
  },

  bulletinContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 16,
  },

  bulletinInfo: {
    flex: 1,
  },

  bulletinTitle: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 4,
    justifyContent: 'flex-start',
  },

  bulletinPeriode: {
    fontSize: 18,
    fontWeight: '600',
    color: '#1e293b',
    marginBottom: 4,
  },

  bulletinAnnee: {
    fontSize: 14,
    color: '#64748b',
    fontWeight: '500',
  },

  bulletinMontant: {
    fontSize: 16,
    color: '#059669',
    fontWeight: '700',
    marginTop: 6,
    backgroundColor: '#ecfdf5',
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 8,
    alignSelf: 'flex-start',
  },

  bulletinStatut: {
    fontSize: 12,
    color: '#f59e0b',
    fontWeight: '600',
    marginTop: 4,
    paddingHorizontal: 8,
    paddingVertical: 2,
    backgroundColor: '#fef3c7',
    borderRadius: 6,
    alignSelf: 'flex-start',
  },

  bulletinPdfButton: {
    padding: 12,
    borderRadius: 8,
    backgroundColor: '#fef2f2',
    borderWidth: 1,
    borderColor: '#fecaca',
    alignItems: 'center',
    justifyContent: 'center',
  },

  bulletinPdfButtonDisabled: {
    backgroundColor: '#f1f5f9',
    borderColor: '#e2e8f0',
  },

  // Styles pour le viewer PDF
  pdfViewerContainer: {
    flex: 1,
    width: '100%',
    height: '100%',
  },

  pdfViewerContainerDialog: {
    width: '100%',
    height: 700,
    minHeight: 500,
  },

  pdfViewer: {
    flex: 1,
    width: '100%',
    height: '100%',
  },

  pdfLoading: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f8fafc',
  },

  pdfLoadingText: {
    marginTop: 16,
    fontSize: 16,
    color: '#64748b',
    textAlign: 'center',
  },

  pdfError: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#fef2f2',
    padding: 20,
  },

  pdfErrorText: {
    marginTop: 16,
    fontSize: 16,
    color: '#ef4444',
    textAlign: 'center',
  },

  // Styles pour le layout desktop
  desktopLayout: {
    flex: 1,
    flexDirection: 'row',
    gap: 20,
  },

  listSide: {
    flex: 1,
    minWidth: 400,
    maxWidth: 500,
  },

  pdfSide: {
    flex: 2,
    backgroundColor: 'white',
    borderRadius: 12,
    overflow: 'hidden',
    // Ombres pour iOS et Web
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    // Elevation pour Android
    elevation: 3,
    borderWidth: 1,
    borderColor: '#e2e8f0',
  },

  pdfPlaceholder: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f8fafc',
    padding: 40,
  },

  pdfPlaceholderText: {
    marginTop: 16,
    fontSize: 16,
    color: '#64748b',
    textAlign: 'center',
    fontWeight: '500',
  },

  tooltipContainer: {
    alignItems: 'center',
    backgroundColor: stdCouleurBleu+'55',
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    width: tooltipContainerWidth,
    marginLeft: 12,
    position: 'relative',
  },

  tooltip: {
    width: 200,
    left: tooltipContainerWidth / 2 - 100, // Centrer le tooltip par rapport à l'icône
  }
})

export default styles
